import { render } from "./AmendBookingPayment.vue?vue&type=template&id=55a7bea3&scoped=true&lang=pug"
import script from "./AmendBookingPayment.vue?vue&type=script&lang=ts"
export * from "./AmendBookingPayment.vue?vue&type=script&lang=ts"

import "./AmendBookingPayment.vue?vue&type=style&index=0&id=55a7bea3&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-55a7bea3"

export default script